export enum InstitutionIntegrationType {
  canvas = 'canvas',
  brightspace = 'brightspace',
}
